<!-- layout / 菜单页 -->
<template>
  <div
    class="layout-container"
    :style="!showNavBar ? 'padding-bottom: 0' : ''"
  >
      <router-view></router-view>
      <!-- 侧边菜单/活动规则等 -->
      <div
        class="aside-menu"
        :style="$route.path === '/' ? 'top: 170px': ''"
      >
        <div
          v-for="(item) in asideList"
          :key="`asideList${item.context}`"
          v-show="$route.path !== '/'"
          @click="openHandler(item.key)"
          class="aside-menu-item-box"
        >
          <div
            class="aside-menu-item"
            :class="item.activeColor"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use :xlink:href="item.icon"></use>
            </svg>
            <div>
              {{ item.context }}
            </div>
          </div>
        </div>

        <div
          v-for="(item) in homeAsideList"
          :key="`homeAsideList${item.context}`"
          v-show="showItem(item.key) && $route.path === '/'"
          @click="openHandler(item.key)"
          class="aside-menu-item-box"
        >
          <div
            class="aside-menu-item"
            :class="item.activeColor"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use :xlink:href="item.icon"></use>
            </svg>
            <div>
              {{ item.context }}
            </div>
          </div>
        </div>
      </div>
      <!-- 底部菜单/我的奖励等 -->
      <nav
        class="main-navbar"
        v-show="showNavBar"
      >
        <div
          v-for="(item, index) in navList"
          :key="item.context"
          class="navbar-item"
          @click="openLink(item.linkUrl, index)"
          :class="{
            'main-navbar-item': index === 1,
            active: item.active
          }"
        >
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use :xlink:href="item.icon"></use>
          </svg>
          <div>
            {{ item.context }}
          </div>
        </div>
      </nav>
      <avtivity ref="avtivity"/>
      <!-- 返回主页 -->
      <div
        v-show="$route.path !== '/'"
        class="go-home"
        @click="$router.push('/')"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon32shouye"></use>
        </svg>
      </div>
      <!-- 邀请码 -->
      <vanOverlay :show="showOverlay">
        <div class="wrapper" @click.stop>
          <div
            class="qr-img"
          >
            <van-loading v-if="loading"/>
            <img
              v-else
              class="img"
              :src="pictureUrl"
            />
          </div>
          <div class="btn">
            <!-- 关闭 -->
            <vanButton
              class="close"
              @click="showOverlay = !showOverlay"
            >
              {{ $t('app.label.shutDown') }}
            </vanButton>
            <vanButton
              class="close"
              @click="copyLink"
            >
              {{ $t('app.label.copyLink') }}
            </vanButton>
            <!-- 保存图片 -->
            <a
              @click.stop.prevent="$toast('请长按图片保存')"
            >
              <vanButton
                class="save"
              >
                {{ $t('app.label.savePicture') }}
              </vanButton>
            </a>
          </div>
        </div>
      </vanOverlay>
    <invitation ref="invitation"/>
  </div>
</template>

<script>
import avtivity from '../activity/index'
import { apiGet } from '@/services'
import Invitation from '../invitation/invitation'

export default {
  name: 'tab-bar-layout',
  components: { avtivity, Invitation },
  data() {
    return {
      loading: true,
      // 底部菜单列表
      navList: [
        {
          active: false,
          icon: '#icon23wodejiangli',
          context: this.$t('app.label.myReward'),
          linkUrl: '/myReward'
        },
        {
          active: false,
          icon: '#icon22yaoqingma',
          context: this.$t('app.label.invitationCode'),
          linkUrl: '/invitationCode'
        },
        {
          active: false,
          icon: '#icon21wodekehu',
          context: this.$t('app.label.myClient'),
          linkUrl: '/myClient'
        }
      ],
      // 侧边菜单列表
      asideList: [
        {
          key: 'settlement',
          activeColor: 'blue',
          icon: '#icon24jiesuanka',
          context: this.$t('app.label.settlementCard')
        },
        {
          key: 'rules',
          activeColor: 'blue',
          icon: '#icon15huodongguize',
          context: this.$t('app.label.activityRules')
        }
      ],
      // 主页登录后专有的菜单
      homeAsideList: [
        // {
        //   key: 'description',
        //   activeColor: 'blue',
        //   icon: '#icon14chanpinjieshao',
        //   context: this.$t('app.label.productDescription')
        // },
        // {
        //   key: 'rules',
        //   activeColor: 'blue',
        //   icon: '#icon15huodongguize',
        //   context: this.$t('app.label.activityRules')
        // },
        // {
        //   key: 'partnerGuidelines',
        //   activeColor: 'blue',
        //   icon: '#iconhehuorenzhiyin',
        //   context: this.$t('app.label.partnerGuidelines')
        // }
      ],
      linkUrl: '',
      showOverlay: false,
      showNavBar: false,
      pictureUrl: '' // 邀请码图片地址
    }
  },
  watch: {
    $route: {
      handler(val) {
        const path = val.path
        this.navList.forEach(item => {
          if (item.linkUrl && path === item.linkUrl) {
            item.active = true
          } else {
            item.active = false
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    async copyLink() {
      if (!this.linkUrl) {
        const res = await apiGet('partner/open/generateInviteLink')
        this.linkUrl = res.data
      }
      this.$copyText(this.linkUrl).then(
        (e) => {
          this.$notify.success(this.$t('app.sentence.copyLinkSuccess'))
        },
        (e) => {
          this.$notify.error(this.$t('app.sentence.copyLinkFail'))
        }
      )
    },
    getQrCode() {
      apiGet('partner/open/generateInviteQrcode').then(res => {
        this.pictureUrl = 'data:image/png;base64,' + res.data.qrcode
      }).then(() => {
        this.loading = false
      })
      apiGet('partner/open/generateInviteLink').then(res => {
          if (res.code === '0000') {
            this.linkUrl = res.data
          }
      })
    },
    // 打开邀请二维码
    openQrCode() {
      this.showOverlay = true
    },
    // 邀请弹窗
    showInvitation() {
      this.$refs.invitation.openShow()
    },
    // 判断展示
    showItem(key) {
      let flag = true
      switch (key) {
        case 'partnerGuidelines':
          flag = this.showNavBar
        break
      }
      return flag
    },
    // 路由跳转，修改active
    openLink(url, index) {
      if (index !== 1) {
        this.navList.forEach((item, idx) => {
          item.active = idx === index
        })
        this.$router.push(url)
      } else {
        this.getQrCode()
        this.showOverlay = true
      }
    },
    openHandler(key) {
      switch (key) {
        case 'settlement': this.toSettle()
        break
        case 'rules': this.showActivity()
        break
        case 'description': window.location.href = 'https://photonpay.com/product'
        break
        case 'partnerGuidelines': this.$router.push({ name: 'guide' })
        break
      }
    },
    // 活动规则
    showActivity() {
      this.$refs.avtivity.openShow()
    },
    // 结算卡
    toSettle() {
      this.$router.push({ name: 'settle' })
    }
  }
}
</script>
<style lang="less" >
  .layout-container {
    padding-bottom: 52px;
  }
  .aside-menu {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 70px;
    z-index: 99;
    right: 0;
    .aside-menu-item-box {
      display: flex;
      align-items: center;
      height: 26px;
      box-sizing: border-box;
      justify-content: flex-end;
      font-size: 13px;
      color: #fff;
      & + .aside-menu-item-box {
        margin-top: 12px;
      }
    }
    .aside-menu-item {
      display: flex;
      padding: 5px 10px;
      align-items: center;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 100px 0px 0px 100px;
      .icon{
        padding-right: 4px;
      }
      &.yellow {
        background:linear-gradient(180deg,rgba(255,214,115,1) 0%,rgba(255,173,41,1) 100%);
      }
      &.blue {
        background: linear-gradient(133deg,#85d784 22%, #00a0e9 84%);
      }
    }
  }
  .main-navbar {
    background-color: #282830;
    height: 52px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    right: 0;
    .navbar-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 36px;
      color: rgba(255,255,255,0.60);
      font-size: 14px;
      max-width: 100px;
      & + .navbar-item {
        margin-left: 20px;
      }
      .icon {
        margin-right: 3px;
      }
      &.main-navbar-item {
        background: #5248e9;
        border-radius:18px;
        color: #fff;
      }
      &.active {
        color: #ffdd3f;
      }
    }
  }
  .go-home {
    position: fixed;
    bottom: 84px;
    right: 16px;
    width: 48px;
    height: 48px;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #737992;
    border-radius: 50%;
    font-size: 24px;
    color: #fff;
  }
  .wrapper {
    height: 100%;
    padding: 30px 0 ;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .qr-img {
      flex: 1;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      padding:0 20px 35px;
      box-sizing: border-box;
      user-select: none;
    }
    .img {
      max-width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .van-overlay {
    z-index: 999;

    .btn {
      height: 50px;
      display: flex;
      width: 100%;
      justify-content: space-around;
      .van-button {
        width: 110px;
      }
    }

    .van-button {
      width: 140px;
      height: 50px;
      border-radius: 25px;
      font-size: 16px;
      font-weight: 500;
    }

    .close {
      color: #565F76;
    }

    .save {
      border: none;
      color: #282D3B;
      background:linear-gradient(90deg,rgba(235,210,164,1) 0%,rgba(227,170,85,1) 100%);
    }
  }

  // 兼容iphone x
  @media screen and (width: 375px) and (height: 724px){
    .layout-container {
      padding-bottom: 86px;
    }
    .main-navbar {
        padding-bottom: 34px;
    }
  }

  // 兼容iphone xr  xrmax
  @media screen and (width: 414px) and (height: 808px){
    .layout-container {
      padding-bottom: 86px;
    }
    .main-navbar {
        padding-bottom: 34px;
    }
  }

</style>
